import React from "react";
import hero1 from "../components/images/hero-1.jpg";
import hero2 from "../components/images/hero-2.jpg";
import happyGroup from "../components/images/globalimg.jpg";
import india from "../components/images/indiaanduk.png";
import russia from "../components/images/russia.png";
import latin from "../components/images/latiinamerica.png";
import southasia from "../components/images/southAsia.png";
import middleEast from "../components/images/middleeast.png";
import africa from "../components/images/africa.png";

function HeroCarousel() {
  return (
    <div>
      <div
        className="carousel header"
        style={{ backgroundImage: `url(${happyGroup})`, height:'500px', }}
      >
        <div className="carousel-content">
          
          <div>
            <h1>
              OUR GLOBAL{" "}
              <span className="primary">PRESENCE</span>
            </h1>
          </div>
        </div>
      </div>

      <div className="Globalpre">
        <h2>Worldwide Operations</h2>
        <ul>
          <li>
            <p>
              <strong>SGMR Pharmaceuticals Pvt Ltd</strong> has its presence in
              more than 80 countries. With established presence in South East
              Asia, Asia Pacific, Africa, North America, EU & EEA, MENA, Latin
              America and CIS countries. (Macleods is now making its presence
              felt in the global pharmaceutical market.)
            </p>
          </li>
          <li>
            <p>
              We operate our International business through various business
              models like Private Markets, Tenders, Licensing, Contract
              manufacturing and Joint Ventures.We have successfully leveraged
              its production and Research & development competency for supplying
              affordable quality pharmaceuticals across the globe. We enjoy a
              unique position in many private markets because of our “know- how”
              in marketing and highly professional sales and marketing team, who
              are the core power of our competitiveness and guarantee of our
              success.
            </p>
          </li>
          <li>
            {" "}
            <p>
              We are in the process of establishing an extensive marketing and
              distribution network in all the countries of presence and (company
              pays more attention to expand its product portfolio) via
              registration and launch of novel pharmaceutical products.
            </p>
          </li>
          <li>
            <p>
              The Regulatory Affairs team with high level of proficiency plays a
              key role in earning registrations of{" "}
              <strong>SGMR Pharmaceuticals Pvt Ltd</strong> products across the
              globe.
            </p>
          </li>
          <li>
            <p>
              <strong>SGMR Pharmaceuticals Pvt Ltd</strong> has established its
              Representative Office in the CIS countries, Latin America, South
              East Asia, Middle East and Africa looking into the business
              potential and the necessity of being at the centre of the action.
            </p>
          </li>
        </ul>

        <div className="country-map">
          <ul>
            <li style={{padding:'20px'}}>
                <h2>Global Registered Office Locations</h2>

              <ul className="county-name">
                <li> &#8594; india</li>
                <li>UK</li>
              </ul>
            </li>
            <li>
              <img src={india}></img>
            </li>
          </ul>
        </div>

        <div className="country-map">
          <ul >
           
            <li style={{padding:'20px'}}>
              <h2>CIS markets</h2>
              <ul className="county-name"> 
                <li>Russia</li>
                <li>Ukraine</li>
                <li>Kazakhstan</li>
                <li>Azerbaijan</li>
                <li>Kyrgyzstan</li>
                <li>Uzbekistan</li>
                <li>Belarus</li>
                <li>Georgia</li>
                <li>Turkmenistan</li>
              </ul>
            </li>

            <li>
              <img src={russia}></img>
            </li>
          </ul>
        </div>

        <div className="country-map">
          <ul>
            <li style={{padding:'20px'}}>
                <h2>Latin America</h2>

              <ul className="county-name">
                <li>Caribbean Islands</li>
                <li>Chile</li>
                <li>Colombia</li>
                <li>Peru</li>
                <li>Venezuela</li>
              </ul>
            </li>
            <li>
              <img src={latin}></img>
            </li>
          </ul>
        </div>

        <div className="country-map">
          <ul>
            
            <li style={{padding:'20px'}}>
                <h2>South East Asia</h2>

              <ul className="county-name">
                <li> Vietnam</li>
                <li>Myanmar</li>
                <li>Thailand</li>
                <li>Philippines</li>
                <li>Srilanka</li>
                <li>Malaysia</li>
                <li>Cambodia</li>
              </ul>
            </li>
            <li>
              <img src={southasia}></img>
            </li>
          </ul>
        </div>

        <div className="country-map">
          <ul>
            <li style={{padding:'20px'}}>
                <h2>Middle East</h2>

              <ul className="county-name">
                <li>Saudi Arabia</li>
                <li>UAE</li>
                <li>Yemen</li>
              </ul>
            </li>
            <li>
              <img src={middleEast}></img>
            </li>
          </ul>
        </div>

        <div className="country-map">
          <ul>
            
            <li style={{padding:'20px'}}>
                <h2>Africa</h2>

              <ul >
                <ul className="county-name">
                  
                    <li>Angola</li>
                    <li>Cameroon</li>
                    <li>Ethiopia</li>
                    <li>Ghana</li>
                    <li>Ivory Coast</li>
                    <li>Kenya</li>
                    <li>Madagascar</li>
                    <li>Tanzania</li>
                    <li>Togo</li>
                    <li>Uganda</li>
                    <li>Zambia</li>
                    <li>Zimbabwe</li>

                  
                </ul>
              </ul>
             
            </li>
            <li>
              <img src={africa}></img>
            </li>
          </ul>
        </div>


      </div>
    </div>
  );
}

export default HeroCarousel;
